function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { cloneElement, useCallback, useEffect, useRef, useState } from "react";
import useStyle from "./Tooltip.styles";
import Portal from "../Portal";
import usePlacement from "../Popper/usePlacement";
import { Popper } from "../Popper";
var Tooltip = function(_param) {
    var accessibilityLabel = _param.accessibilityLabel, _defaultOpen = _param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, disabled = _param.disabled, _dismissDelay = _param.dismissDelay, dismissDelay = _dismissDelay === void 0 ? 400 : _dismissDelay, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _maxWidth = _param.maxWidth, maxWidth = _maxWidth === void 0 ? 282 : _maxWidth, _onClose = _param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _onOpen = _param.onOpen, onOpen = _onOpen === void 0 ? function() {} : _onOpen, _placement = _param.placement, placement = _placement === void 0 ? 'bottom' : _placement, portal = _param.portal, _preventOverflow = _param.preventOverflow, preventOverflow = _preventOverflow === void 0 ? true : _preventOverflow, _arrowPadding = _param.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 12 : _arrowPadding, text = _param.text, trigger = _param.trigger, rest = _objectWithoutProperties(_param, [
        "accessibilityLabel",
        "defaultOpen",
        "disabled",
        "dismissDelay",
        "isRtl",
        "maxWidth",
        "onClose",
        "onOpen",
        "placement",
        "portal",
        "preventOverflow",
        "arrowPadding",
        "text",
        "trigger"
    ]);
    var position = usePlacement(placement, isRtl);
    var ref = _slicedToArray(useState(defaultOpen), 2), isOpen = ref[0], setIsOpen = ref[1];
    var popperRef = useRef(null);
    var triggerRef = useRef(null);
    var triggerContainerRef = useRef(null);
    useEffect(function() {
        var handleEsc = function(event) {
            if (event.keyCode === 27 && isOpen) {
                setIsOpen(false);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return function() {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [
        isOpen
    ]);
    var ref1 = useStyle(isRtl, maxWidth), caret = ref1.caret, tooltipWrapper = ref1.tooltipWrapper;
    var closeTimeout = useRef();
    var handleOpen = useCallback(function() {
        onOpen();
        if (closeTimeout.current && typeof window !== 'undefined') {
            clearTimeout(closeTimeout.current);
            closeTimeout.current = undefined;
        }
        setIsOpen(true);
    }, [
        onOpen
    ]);
    var handleClose = useCallback(function() {
        if (typeof window !== 'undefined') {
            var id = setTimeout(function() {
                onClose();
                setIsOpen(false);
            }, dismissDelay);
            closeTimeout.current = id;
        } else {
            onClose();
        }
    }, [
        onClose
    ]);
    var correctedPreventOverflow = portal ? false : preventOverflow;
    var _arrowLabel;
    return _jsxs(_Fragment, {
        children: [
            _jsx("div", {
                ref: triggerContainerRef,
                children: typeof trigger === 'function' ? trigger(handleOpen, handleClose, triggerRef) : cloneElement(trigger, {
                    tabIndex: 0,
                    onMouseEnter: handleOpen,
                    onMouseLeave: handleClose,
                    onFocus: handleOpen,
                    onBlur: handleClose,
                    ref: triggerRef,
                    forwardedRef: triggerRef
                })
            }),
            _jsx(Portal, {
                portal: portal,
                children: _jsx("div", {
                    onMouseEnter: handleOpen,
                    onMouseLeave: handleClose,
                    children: _jsx(Popper, _objectSpread({}, rest, {
                        animationFunction: "expressive",
                        arrowPadding: arrowPadding,
                        arrowStyles: caret,
                        arrowLabel: (_arrowLabel = rest.arrowLabel) !== null && _arrowLabel !== void 0 ? _arrowLabel : accessibilityLabel,
                        arrowSize: "small",
                        children: text,
                        flip: !correctedPreventOverflow,
                        hide: correctedPreventOverflow,
                        isOpen: !disabled && isOpen,
                        isRtl: isRtl,
                        placement: position,
                        popperRef: popperRef,
                        popperStyles: tooltipWrapper,
                        preventOverflow: correctedPreventOverflow,
                        role: "tooltip",
                        triggerRef: (triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) ? triggerRef : triggerContainerRef
                    }))
                })
            })
        ]
    });
};
export { Tooltip };
export default Tooltip;
